import React from 'react';
import { MarkdownPresenter } from './MarkdownPresenter.js';
export const LegalText = (props) => (React.createElement(MarkdownPresenter, { key: "markdown", markdownContent: props.body }));
